import {
  FETCH_PROMISED_PAYMENT_SETTINGS,
  FETCH_PROMISED_PAYMENT,
  DROP_PROMISED_PAYMENT_DATA,
  RESET_PROMISED_PAYMENT_DATA,
  CREATE_PROMISED_PAYMENT_REQUEST,
  FETCH_TAKEN_PROMISED_PAYMENT,
} from 'modules/Finance/PromisedPayment/store/types'

export const actionGetSettings = () => ({ type: FETCH_PROMISED_PAYMENT_SETTINGS })

export const actionGetPromisedPayment = (props) => ({
  type: FETCH_PROMISED_PAYMENT,
  payload: props,
})
export const actionDropPromisedPayment = () => ({ type: DROP_PROMISED_PAYMENT_DATA })
export const actionResetPromisedPayment = () => ({ type: RESET_PROMISED_PAYMENT_DATA })

export const actionCreatePromisedPaymentRequest = (props) => ({
  type: CREATE_PROMISED_PAYMENT_REQUEST,
  payload: props,
})

export const actionGetTakenPromisedPayment = () => ({ type: FETCH_TAKEN_PROMISED_PAYMENT })
